export const config = {
	icon: {
		size: 40,
		color: 'primary'
	}
};
